<template>
  <v-container>
    <h2 class="text-lg-center text-md-center text-sm-center earth-color">MEMBERSHIP PAYMENT</h2>
    <br>
    <v-layout row wrap>
    <v-flex lg4 md4 sm4 xs4 v-if="$paymentOptions[1].active === true">
      <v-card max-width="400" flat>
        <img src="https://marketplace.datingpro.com/image/data/payment%20systems/m-pesa-integration.png" width="100%" height="100%" class="center-block"/>
        <v-card-title primary-title>
          <div>
            <h1 class="earth-color">MPESA</h1>
            <!--<div>Kindly note that payments above KES 250,000 will not have the mpesa option.</div>-->
          </div>
        </v-card-title>

        <v-card-actions>
          <!--<v-btn flat color="primary">PAY NOW</v-btn>-->
          <input v-model="payment_mode" type="radio" value="Mpesa" class="form-control">
        </v-card-actions>
      </v-card>
    </v-flex>
      <v-flex lg4 md4 sm4 xs4 v-if="$paymentOptions[0].active === true">
        <v-card max-width="400" flat>
              <img src="https://www.freeiconspng.com/uploads/credit-cards-icon-25.png" width="100%" height="100%" alt="">
          <v-card-title primary-title>
            <div>
              <h1 class="earth-color">IVERI</h1>
              <!--<div>Kindly note that payments above KES 250,000 will not have the mpesa option.</div>-->
            </div>
          </v-card-title>

          <v-card-actions>
            <!--<v-btn flat color="primary">PAY NOW</v-btn>-->
            <input v-model="payment_mode" type="radio" value="Card" class="form-control">
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex lg4 md4 sm4 xs4 v-if="$paymentOptions[2].active === true">
        <v-card max-width="400" flat>
          <img src="https://pbs.twimg.com/media/Dumm6dNW4AA7oDR.jpg" width="100%" height="100%" class="center-block"/>
          <v-card-title primary-title>
            <div>
              <h1 class="earth-color">EQUITY</h1>
              <!--<div>Kindly note that payments above KES 250,000 will not have the mpesa option.</div>-->
            </div>
          </v-card-title>

          <v-card-actions>
            <!--<v-btn flat color="primary">PAY NOW</v-btn>-->
            <input v-model="payment_mode" type="radio" value="jenga" class="form-control">
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <br>
    <v-card v-if="payment_mode === 'jenga'">
      <v-container>
        <h2 class="text-lg-center text-md-center text-sm-center earth-color">MEMBERSHIP PAYMENT</h2>
        <h4 class="text-lg-center text-md-center text-sm-center earth">KES {{paymentUSDPrice / 100}}</h4>
        <div class="col-md-12 text-center">
          <form id="eazzycheckout-payment-form" action=" https://api-test.equitybankgroup.com/v2/checkout/launch" method="POST">
            <input type="hidden" id="token" name="token" :value="$JengaAuth['payment_token']">
            <input type="hidden" id="amount" name="amount" :value="paymentUSDPrice">
            <input type="hidden" id="orderReference" name="orderReference" :value="singleMember.public_id">
            <input type="hidden" id="merchantCode" name="merchantCode" value="8546918347">
            <input type="hidden" id="merchant" name="merchant" value="Ol Pejeta Ranching" >
            <input type="hidden" id="custName" name="custName" :value="singleMember.first_name">
            <input type="hidden" id="outletCode" name="outletCode" value="0000000000">
            <input type="hidden" id="popupLogo" name="popupLogo">
            <input type="hidden" id="ez1_callbackurl" name="ez1_callbackurl">
            <input type="hidden" id="ez2_callbackurl" name="ez2_callbackurl">
            <input type="hidden" id="expiry" name="expiry" value="2025-02-17T19:00:00">
            <v-btn type="submit" id="submit-cg" role="button" class="btn btn-primary col-md-4 text-center" value="Checkout" color="primary" target="_blank">Checkout</v-btn>
          </form>
        </div>
      </v-container>
    </v-card>
    <v-card flat v-if="payment_mode === 'Card'" >
      <v-container>
        <div class="col-md-12">
          <div class="">
            <div class="">
              <form id="myform" name="myform" METHOD="POST" ACTION="https://portal.host.iveri.com/Lite/Authorise.aspx">
                <!-- Mandatory form variables  -->
                <input id="Lite_Merchant_Applicationid" name="Lite_Merchant_Applicationid" type="hidden" :value="kes_live_id" readonly="true">
                <input id="Lite_Order_Amount" name="Lite_Order_Amount" type="hidden" :value="paymentUSDPrice" readonly="true">
                <input type="hidden" name="Lite_Website_Successful_url" :value="iveri_catcher_url + 'member-payment'" /> <!-- NEED TO BE CHANGED -->
                <input type="hidden" name="Lite_Website_Fail_url" :value="iveri_url + '/membership-payment/'+singleMember.public_id"  /> <!-- NEED TO BE CHANGED -->
                <input type="hidden" name="Lite_Website_TryLater_url" :value="iveri_url + '/membership-payment/'+singleMember.public_id"  /> <!-- NEED TO BE CHANGED -->
                <input type="hidden" name="Lite_Website_Error_url" :value="iveri_url + '/membership-payment/'+singleMember.public_id"  /> <!-- NEED TO BE CHANGED -->
                <input id="Lite_Currency_AlphaCode" name="Lite_Currency_AlphaCode" type="hidden" value="KES" readonly="true">
                <input id="Lite_Order_LineItems_Product_1" name="Lite_Order_LineItems_Product_1" type="hidden" value="Membership Total" readonly="true">
                <input id="Lite_Order_LineItems_Quantity_1" name="Lite_Order_LineItems_Quantity_1" type="hidden" value="1" readonly="true">
                <input id="Lite_Order_LineItems_Amount_1" name="Lite_Order_LineItems_Amount_1" type="hidden" :value="paymentUSDPrice" readonly="true">
                <input id="Lite_ConsumerOrderID_PreFix" name="Lite_ConsumerOrderID_PreFix" type="hidden" value="DML" readonly="true">
                <input id="Ecom_BillTo_Online_Email" name="Ecom_BillTo_Online_Email" type="hidden" :value="singleMember.email">
                <input id="Ecom_Payment_Card_Protocols" name="Ecom_Payment_Card_Protocols" type="hidden" value="iVeri" readonly="true">
                <input id="MemberId" name="MemberId" type="hidden" :value="singleMember.public_id">
                <input id="Ecom_TransactionComplete" name="Ecom_TransactionComplete" type="hidden" value="" readonly="true">
                <!-- End-->
                <font color="red"><p class="warningtext" id="warning" name="warning" >&nbsp;</p></font>
                <li>
                  <v-text-field
                    id="txtEmail"
                    name="txtEmail"
                    v-model="singleMember.email"
                    :rules="requiredRules"
                    label="Email"
                    required
                  ></v-text-field>
                </li>
                <li>
                  <input type="text" hidden="hidden" id="Amount" name="Amount" class="text"  :value="paymentUSDPrice"><a href="#" class=" icon user" tabindex="-1"></a>
                </li>

                <br>
                <div class="submit">
                  <v-btn :depressed="true" type="submit" id="btnsubmit" class="btn primary btn-block" name="btnsubmit" color="primary">Proceed to Card Payment</v-btn>
                  <br>
                  <br>
                  <h3 class="text-center earth">PLEASE RE-CONFIRM YOUR EMAIL ADDRESS TO PROCEED WITH PAYMENT</h3>
                  <div class="clear">  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      </v-container>
    </v-card>
    <v-card flat v-if="payment_mode === 'Mpesa'">
      <v-card flat>
        <v-container fluid>
          <div class="earth text-center">KINDLY NOTE THAT PAYMENTS ABOVE KES 250,000 CANNOT BE PROCESSED</div>
          <br/>
          <br/>
          <v-layout>
            <v-flex lg3 md3></v-flex>
            <v-flex lg12 md12 sm12 xs12>
              <v-text-field
                label="Safaricom Phone Number"
                v-model="phone_number"
                required
                type="tel"
                placeholder="254..."
              ></v-text-field>
              <v-layout row wrap>
                <v-flex lg6 md6 sm12 xs12>
                  <v-container>
                    <v-btn :depressed="true" color="primary" block @click="requestMpesa()">Request Payment</v-btn>
                  </v-container>
                </v-flex>
                <v-flex lg6 md6 sm12 xs12>
                  <v-container>
                    <v-btn :depressed="true" color="warning" block @click="confirmPayment()" v-if="confirm === true">Confirm Payment</v-btn>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-card>
    {{paymentCheck}}
  </v-container>
</template>

<script>
export default {
  name: 'membership-payment',
  data () {
    return {
      confirm: false,
      payment_mode: '',
      memberId: this.$route.params.member_id,
      phone_number: '254'
    }
  },
  beforeCreate () {
    this.$store.dispatch('get_payment_platforms')
  },
  created () {
    this.$store.dispatch('get_member', this.$route.params.member_id)
    this.$store.dispatch('get_jenga_auth')
    
    
  },
  computed: {
    paymentCheck () {
      if (this.singleMember.payment_status === true || this.singleMember.payment_status === 'true') {
        this.redirectToSuccessPage()
      }
      return null
    },
    paymentKESPrice: function () {
      return Number(this.singleMember.amount)
    },
    paymentUSDPrice: function () {
      var total = 0
      total = this.singleMember.amount * 100
      return total
    }
  },
  methods: {
    redirectToSuccessPage () {
      this.$router.push({
        name: 'SuccessMembership'
      })
    },
    confirmPayment () {
      this.$store.dispatch('get_member', this.$route.params.member_id)
    },
    requestMpesa () {
      this.confirm = true
      var data = {
        reference_number: this.$route.params.member_id,
        phone_number: this.phone_number
      }
      this.$store.dispatch('member_request_mpesa', data)
    }
  }
}
</script>

<style scoped>
  li {
    text-decoration: none;
    list-style: none;
  }
</style>
